<form (submit)="submit()" [formGroup]="form" class="grid grid-cols-12" novalidate>
  @if (!variable.isBetriebsVariable && !active) {
    <p-message class="col-span-12 mb-2" severity="info">
      <div translate>VARIABLES.VARIABLE_NOT_ACTIVATED</div>
    </p-message>
  }

  @if (variable.isBetriebsVariable) {
    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="parentName"
      label="VARIABLES.PARENT_NAME"></app-form-text-input>
  }

  <app-form-text-input [form]="form" [twoColumns]="true" id="tacsId" label="VARIABLES.TACS_ID"></app-form-text-input>

  <app-form-text-input
    [form]="form"
    [label]="variable.isBetriebsVariable ? 'GLOBAL.NAME' : 'VARIABLES.NAME'"
    [maxLength]="50"
    [twoColumns]="true"
    id="name"></app-form-text-input>

  @if (!variable.isBetriebsVariable) {
    @for (language of languages; track $index) {
      <app-form-text-input
        [form]="form"
        [id]="'customName.' + language"
        [label]="'GLOBAL.NAME_' + language"
        [twoColumns]="true"></app-form-text-input>
    }
  }

  <app-form-text-input
    [form]="form"
    [label]="variable.isBetriebsVariable ? 'GLOBAL.DESCRIPTION' : 'VARIABLES.DESCRIPTION'"
    [textArea]="true"
    [twoColumns]="true"
    id="description"></app-form-text-input>

  <app-form-text-input
    [form]="form"
    [label]="variable.isBetriebsVariable ? 'VARIABLES.COMMENT' : 'VARIABLES.COMMENT_PROPOSAL'"
    [textArea]="true"
    [twoColumns]="true"
    id="comment"></app-form-text-input>

  @if (!variable.isBetriebsVariable) {
    @for (language of languages; track $index) {
      <app-form-text-input
        [form]="form"
        [id]="'customComment.' + language"
        [label]="'VARIABLES.COMMENT_' + language"
        [textArea]="true"
        [twoColumns]="true"></app-form-text-input>
    }
  }

  <app-form-switch [form]="form" [twoColumns]="true" id="isLocked" label="VARIABLES.LOCKED"></app-form-switch>

  <app-form-switch
    [form]="form"
    [twoColumns]="true"
    id="isCustomNameApproved"
    label="GLOBAL.APPROVED"></app-form-switch>

  <app-form-switch [form]="form" [twoColumns]="true" id="isMeasure" label="VARIABLES.MEASURE"></app-form-switch>

  @if (!variable.isBetriebsVariable) {
    <app-form-text-input
      [form]="form"
      [twoColumns]="true"
      id="foreignCode"
      label="VARIABLES.FOREIGN_CODE"></app-form-text-input>
  }

  @if (variable.isBetriebsVariable) {
    <app-form-date-input
      [form]="form"
      [twoColumns]="true"
      id="validFrom"
      label="GLOBAL.GUELTIG_AB"></app-form-date-input>
  }

  @if (variable.isBetriebsVariable) {
    <app-form-date-input
      [form]="form"
      [minDate]="form.controls.validFrom.value"
      [twoColumns]="true"
      id="validTo"
      label="GLOBAL.GUELTIG_BIS"></app-form-date-input>
  }

  @if (variable.isBetriebsVariable) {
    <app-form-number-input
      [form]="form"
      [twoColumns]="true"
      id="parentSortIndex"
      label="VARIABLES.PARENT_SORT_INDEX"></app-form-number-input>
  }

  <app-form-number-input
    [form]="form"
    [twoColumns]="true"
    id="sortIndex"
    label="VARIABLES.SORT_INDEX"></app-form-number-input>

  <app-form-time-period
    [form]="form"
    [maxDate]="form.controls.validTo.value"
    [minDate]="form.controls.validFrom.value"
    id="entries"
    label="VARIABLES.VALIDITY_PERIOD"></app-form-time-period>

  @if (variable.isBetriebsVariable && isMeasure()) {
    <app-form-number-input
      [form]="form"
      [twoColumns]="true"
      id="leistungsgewicht"
      label="VARIABLES.LEISTUNGSGEWICHT"></app-form-number-input>
  }

  <app-form-button-bar (onCancel)="close()" [form]="form" [saveDisabled]="submitting">
    @if (variable.isBetriebsVariable && isRodixAdmin() && this.variable.id) {
      <p-button
        (onClick)="delete()"
        [label]="'ACTIONS.DELETE' | translate"
        icon="fal fa-trash"
        styleClass="p-button-danger"
        type="button"></p-button>
    }
  </app-form-button-bar>
</form>
